import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';
import { useFormParams, useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { selectPersonalAccidentQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  return useMemo(() => {
    if (!personalAccidentQuote) return;
    const { members } = personalAccidentQuote;
    return mergeInitialValues(
      values,
      members,
      params,
    );
  }, [personalAccidentQuote]);
};
